import {
  Document,
  RoadmapTask,
  TaskManualStatus,
  TaskState,
  User,
} from "@models";
import { getDocumentTaskStatus, isStatusComplete } from "@utils";

/**
 * Get the effective status for a task based on its type
 * - DOCUMENT tasks: status is derived from the linked document's status
 * - MANUAL tasks: status is stored in the task instance
 */
export const getEffectiveTaskStatus = ({
  task,
  instance,
  documents,
  user,
  orgId,
}: {
  task: RoadmapTask;
  instance?: TaskState;
  documents: Document[];
  user: User;
  orgId: string;
}) => {
  if (task.taskConfig.taskType === "DOCUMENT") {
    // Derive status from document
    return getDocumentTaskStatus({
      templateKey: task.taskKey,
      documents,
      user,
      orgId,
    });
  } else {
    // Use instance status or default to TODO
    return instance?.manualStatus ?? TaskManualStatus.TODO;
  }
};

/**
 * Check if a task is considered complete
 * - DOCUMENT tasks: document status is LIVE or ARCHIVED
 * - MANUAL tasks: instance status is DONE
 */
export const isTaskComplete = ({
  task,
  instance,
  documents,
  user,
  orgId,
}: {
  task: RoadmapTask;
  instance?: TaskState;
  documents: Document[];
  user: User;
  orgId: string;
}) => {
  if (task.taskConfig.taskType === "DOCUMENT") {
    const docStatus = getDocumentTaskStatus({
      templateKey: task.taskKey,
      documents,
      user,
      orgId,
    });
    return isStatusComplete(docStatus);
  } else {
    // Manual task is complete when status is DONE
    return instance?.manualStatus === TaskManualStatus.DONE;
  }
};

export const areAllCardTasksCompleted = (
  cardTasks: RoadmapTask[],
  _cardDocuments: Document[], // Kept for backward compatibility, not used
  user: User,
  documents: Document[],
  orgId: string,
  taskInstances?: TaskState[]
) => {
  // if the card is empty then it is not completed
  if (cardTasks.length === 0) {
    return false;
  }

  return cardTasks.every((task) => {
    const instance = taskInstances?.find((i) => i.taskKey === task.taskKey);

    return isTaskComplete({
      task,
      instance,
      documents,
      user,
      orgId,
    });
  });
};
